@if (serie.isVisible) {
  <svg:path
    [ngClass]="'line'"
    [attr.d]="lineString"
    [style.stroke]="serie.config.color"
    [style.stroke-width]="serie.config.width">
    </svg:path>
  }
